import{_ as r}from"./_trimmedEndIndex.js";var e=r,a=/^\s+/;var n=function(r){return r?r.slice(0,e(r)+1).replace(a,""):r};export{n as _};
